// extracted by mini-css-extract-plugin
export default {"root":"RemoveSuperBatchesToggleChips_root__V34N4","superBatchSelect":"RemoveSuperBatchesToggleChips_superBatchSelect__r4NZB"};